<template>
  <div
    class="kt-quick-search kt-quick-search--dropdown kt-quick-search--result-compact"
    id="kt_quick_search_dropdown"
  >
    <form
      method="get"
      class="kt-quick-search__form"
      @submit.prevent="searchHandler"
    >
      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text">
            <i class="flaticon2-search-1"></i>
          </span>
        </div>
        <input
          v-model="search"
          type="text"
          class="form-control kt-quick-search__input"
          placeholder="Search..."
        />
        <div class="input-group-append">
          <span class="input-group-text">
            <i class="la la-close kt-quick-search__close"></i>
          </span>
        </div>
      </div>
    </form>
    <div
      class="kt-quick-search__wrapper kt-scroll"
      data-scroll="true"
      data-height="325"
      data-mobile-height="200"
    ></div>
  </div>
</template>
<script>
export default {
  name: 'DropSearch',
  data: () => ({
    search: '',
  }),
  methods: {
    searchHandler() {
      this.$router.push({ path: '/search/result', query: { s: this.search } });
    },
  },
};
</script>
